import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

let initialized = false;

function ensureOptions() {
  if (!initialized) {
    setOptions({
      key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      v: "weekly",
    });
    initialized = true;
  }
}

export async function loadGooglePlaces() {
  ensureOptions();
  await importLibrary("places");
}

export async function loadGoogleMapsCore() {
  ensureOptions();
  await importLibrary("maps");
}
